module.exports = __webpack_public_path__ + "img/benben tsukumo_lw.a17159f8.png";